import { render, staticRenderFns } from "./SystemSettingsList.vue?vue&type=template&id=3530a4da&scoped=true"
import script from "./SystemSettingsList.vue?vue&type=script&lang=js"
export * from "./SystemSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530a4da",
  null
  
)

export default component.exports